<template>
  <transition enter-active-class="animated slideInRight">
    <nav
      v-if="isActive"
      id="sidebar"
      v-click-outside="showMenu"
      :class="{ active: isActive }"
    >
      <div class="sidebar-header"> 
        <img 
         @click="showMenu()"
        src="@/assets/media/icons/duotone/Interface/Close-Square.svg"
         style="      
          width: 30px;
          height: 30px; "
        />
        
      </div> 
      <ul class="pl-2" style="list-style: none"> 
        <li v-if="user" class="mb-5"> 
          <p>{{ $t('welcome') }}</p>
          <p> <strong>{{ user.contact_fullname || 'Unknown' }}</strong></p>
          <br>
          <p>Email: {{ user.email }} </p>
          <p>Phone: {{ user.phone }} </p> 
        
        </li>
        <li>
            <p v-if="!user" @click="login()" class="pointer">   
               {{ $t("SignUp/SignIn") }}
           </p> 
           <hr>
        </li>

        <li>
            <p v-if="authCheck" @click="SignOut()"> 
              <img src="@/assets/media/icons/duotone/Interface/Sign-Out.svg"/> {{ $t("sign_out") }}
           </p> 
        </li>

        <li v-if="authCheck" @click="openPage('orders')">
          <p>
            <img src="@/assets/media/icons/duotone/Food/French-Fries.svg"/>
            {{ $t("orders") }}   
            <span class="badge badge-warning">{{ number }} </span>
          </p>
        </li>

        <template v-if="langs.length > 1">
          <li>
            <p> <img src="@/assets/media/icons/duotone/Contacts/Flag.svg"/>
             {{ $t("lang") }}:</p>
            <div class="row mt-3 ml-1">
              <div v-for="lang in langs" :key="lang.name" class="col-6">
                <a href="#" class="d-flex language_text" @click="setLocale(lang.code)">
                  <img
                    :src="require(`@/assets/flags/${lang.code}.svg`)"
                    class="flag_icon"
                  />
                  {{ lang.name }}
                </a>
              </div>
            </div>
          </li> 
        </template>
      </ul>
    </nav>
  </transition>
</template>
<style lang="css">
  li > p >img{
    margin-right: 15px ;
  }
  
</style>
<script>
import { loadMessages } from "../plugins/i18n";
import { mapGetters } from "vuex";
import store from "@/store";
import redirectLogin from '@/helper/redirect';

export default {
  name: "NavVertical",
  computed: mapGetters({
    isActive: "nav/nav",
    user: "auth/user",
    langs: "lang/locales",
    authCheck: "auth/check",
    number: "nav/pending_number",
  }),
  created() {
    this.$store.dispatch("lang/fetchLangs");
  },
  methods: {
    setLocale(locale) {
      if (this.$i18n.locale !== locale) {
        loadMessages(locale);
        this.$store.dispatch("lang/setLocale", { locale });
      }
      window.location.reload();
    },
    showMenu() {
      this.$store.dispatch("nav/nav_menu");
    },
    openPage(page) {
      this.$router.push(page);
      this.showMenu();
    },
    async SignOut() {
      await store.dispatch("auth/LogOut");
      this.$store.dispatch("nav/nav_menu");
      this.$router.push({ name: "province" });
    },
    login() { 
      window.location.href = redirectLogin;
    },
  },
};
</script>